// runs in browser only

import './registerServiceWorker.js';
import { createApp } from './main';
import bugsnag from 'bugsnag-js';
import bugsnagVue from 'bugsnag-vue';
//import VueFacebookPixel from 'vue-analytics-facebook-pixel';

createApp()
.then( ({app, router, cache, store, Vue}) => {

  //Vue.use(VueFacebookPixel)
  const bugsnagClient = bugsnag('ac9dc524a20d8733884a19692d26cd5c')
  if (window.location.hostname !== 'localhost') {
    bugsnagClient.use(bugsnagVue(Vue));
  }
  // eslint-disable-next-line no-underscore-dangle
  if (window.__INITIAL_STATE__) {
    // We initialize the store state with the data injected from the server
    // eslint-disable-next-line no-underscore-dangle
    store.replaceState(window.__INITIAL_STATE__);
  }

  // await before instantiating ApolloClient, else queries might run before the cache is persisted
  if (window.__APOLLO_STATE__) {
    const state = window.__APOLLO_STATE__;
    console.log('wuts in the state luls', JSON.stringify(state,0,2));
    cache.restore(state.defaultClient);
  }


  router.onReady(() => {
    app.$mount('#app');
    //console.log('log to facebook pixel');
    //Vue.analytics.fbq.init('3432666486816078');
    //Vue.analytics.fbq.event('PageView');
  });
});

